// src/pages/Explore.js
import React from 'react';
import { Link } from 'react-router-dom';
import { newsCategories } from '../utils/constants';
import CategoryNewsSection from '../components/CategoryNewsSection';
import StockTicker from '../components/StockTicker';
import './Explore.css';

const Explore = () => {
    return (
        <div className="explore-page">
            {/* 1. Stock values scrolling at the absolute top */}
            <div className="explore-ticker-container">
                <StockTicker />
            </div>
            
            {/* 2. Restored Live Cricket Tab stretched to full screen width */}
            <div className="live-cricket-container">
                <Link to="/live-cricket" className="cricket-link-centered-full">
                    <span className="cricket-dot"></span>
                    <span className="tab-text-content" style={{ color: '#0056b3' }}>
                        Live Cricket
                    </span>
                </Link>
            </div>

            {/* 3. Scrolling Category News Section (No headers or blue backgrounds) */}
            <div className="explore-category-section">
                <CategoryNewsSection categories={newsCategories} />
            </div>
        </div>
    );
};

export default Explore;